import styled from 'styled-components'

import { DashboardTypeItem, SpinnerWithText } from 'src/components'

export const StyledDashboardTypeItem = styled(DashboardTypeItem)`
  margin-bottom: 0.8rem;
`

export const StyledSpinnerWithText = styled(SpinnerWithText)`
  margin: 2.4rem 0;
`

export const List = styled.div`
  margin-top: 2.4rem;
`

export const Actions = styled.div`
  display: flex;

  > :first-child {
    margin: 0 0.8rem !important;
  }
`
